<template>
  <div class="item">
    <!-- {{broadcastContent}} -->
    <div class="sender">{{$t('global.sender') + ': ' + broadcastContent.orgName + ' - ' + broadcastContent.userName }}
      <div class="time">{{$moment(broadcastContent.timestamp * 1000).format('YYYY-MM-DD HH:mm')}}</div>
    </div>
    <div class="item-content">{{$t('global.content') + ': ' + broadcastContent.content}}</div>
    <div class="total">
      <div>{{$t('global.sendingStatus')}}</div>
      <!-- <StatusChart :status=broadcastContent.entitys /> -->
    <div class="action">
      <div class="action-item success">
        <div class="title">
          {{$t('global.total') + ` ${sendOk.length} ` +  $t('global.fscg') + ',' + $t('global.qz') + ` ${sendOk.filter((item) => item.read_confirm).length} ` + $t('global.yd')}}
        </div>
        <!-- <div class="title">
          {{`共${sendOk.filter((item) => item.read_confirm).length}人已读`}}
        </div> -->
        <div class="list">
          <template v-for="(item,index) in sendOk">
            <div :key="index" class="reason">
              <div>{{item.entityName}}</div>
              <div>{{item.read_confirm ? $t('global.read') : $t('global.unread')}}</div>
            </div>
          </template>
          <!-- {{sendOk.map((item) => item.entityName).join(',')}} -->
        </div>
      </div>
      <div class="action-item pending">
        <div class="title">
          {{$t('global.total') + ` ${sendPending.length} ` + $t('global.inProgress')}}
        </div>
        <div class="list">
           {{sendPending.map((item) => item.entityName).join(',')}}
        </div>
      </div>
      <div class="action-item fail">
        <div class="title">{{$t('global.total') + ` ${sendFail.length} ` + $t('global.fssb')}}</div>
        <a-button v-if="sendFail.length > 0" @click="resend" type="primary" size="small">{{ $t('global.resend') }}</a-button>
        <div class="list">
          <template v-for="(item,index) in sendFail">
            <div class="reason" :key="index">
              <div>{{item.entityName }}</div>
              <div>{{getFailReason(item.status)}}</div>
            </div>
          </template>
          <!-- {{sendFail.map((item) => item.entityName).join(',')}} -->
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import config from '../../config'
import {formatFailReason} from './formatChart'
export default {
  props: {
    broadcastContent: {
      required: true
    }
  },
  computed: {
    sendOk () {
      return this.broadcastContent.entitys.filter((item) => item.status === 0)
    },
    sendPending () {
      return this.broadcastContent.entitys.filter((item) => item.status === 2)
    },
    sendFail () {
      return this.broadcastContent.entitys.filter((item) => item.status !== 0 && item.status !== 2)
    },
  },
  components: {
    StatusChart: () => import('./StatusChart')
  },
  methods: {
    getFailReason(type){
      switch(type){
        case 0:
          return this.$t('global.cg');
        case 1:
          return this.$t('global.wlbd');
        case 2:
          return this.$t('global.zxz');
        case 3:
          return this.$t('global.sbzxsb');
        case 4:
        case 5:
          return this.$t('global.cs');
        case 6:
          return this.$t('global.wbdsb');
      }
    },
    formatFailReason,
    resend () {
      // console.log(this.broadcastContent)
      let param = this.broadcastContent.entitys.filter((item) => item.status !== 0 && item.status !== 2).map((entity) => entity.id)
      // console.log(param)
      this.$http.post(config.api.resend_broadcast_message, param).then((res) => {
        // console.log(res)
        if (res.code === 0) {
          this.$emit('resend', this.broadcastContent)
          this.$notification.success({
            message: this.$t('global.cxfs')
          })
        } else {
          this.$notification.error({
            message: res.desc
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.item {
  height: 560px;
  padding: 0 5px;
  margin: 0;
  overflow-y: auto;
  // width: 650px;
  // max-width: 650px;
  // box-shadow: .5px 0 1px #ccc;
  // border-bottom: .5px solid #ccc;
  .default-box {
    background: rgb(255, 255, 255);
    border-radius: 5px;
    margin-top: 10px;
    padding: 10px;
  }
  .sender {
    font-size: 1.1em;
    padding: 10px;
    background: rgb(255, 255, 255);
    color: @heading-color;
    border-radius: 5px; 
    .time {
      font-size: .9em;
      color: @text-color-secondary;
    }
  }
  .item-content {
    margin-top: 10px;
    font-size: 1em;
    padding: 10px;
    // background: rgba(170, 170, 170, 0.377);
    background: rgb(255, 255, 255);
    border-radius: 5px;
    color: @heading-color;
  }
  .action {
    // .default-box;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    .success {
      background: rgba(24, 153, 104, 0.3) !important;
    }
    .pending {
      background: rgba(92, 99, 34, 0.3) !important;
    }
    .fail {
      background: rgba(146, 21, 21, 0.3) !important;
    }
    .action-item {
      .default-box;
      .title {
        font-size: 1.1em;
        color: rgb(0, 0, 0);
      }
      .list {
        color: rgb(51, 51, 51);
        max-height: 80px;
        overflow-y: auto;
        .reason {
          display: grid;
          grid-template-columns: 1fr 2fr;
          grid-gap: 5px;
        }
      }
    }
  }
  .total {
    .default-box;
  }
}
</style>